/* unplugin-vue-components disabled */import { render } from "./SysCogOthers.vue?vue&type=template&id=69ae97d8&scoped=true"
import script from "./SysCogOthers.vue?vue&type=script&lang=js"
export * from "./SysCogOthers.vue?vue&type=script&lang=js"

import "./SysCogOthers.vue?vue&type=style&index=0&id=69ae97d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ae97d8"]])

export default __exports__